export const redirectTo = (pathname: string): void => {
  window.location.assign(pathname);
};

export const isRootLocation = (): boolean => window.location.pathname === '/';

export const redirectToRoot = (): void => {
  redirectTo('/');
};

export const getBaseUrl = (): string => window.location.origin;

export const createAuthCallback = (callback?: string): string => {
  const callbackToCall = callback ?? process.env.REACT_APP_BASE_URL;
  return callbackToCall ? `callback=${callbackToCall}` : '';
};

export const redirectToLogout = (callback?: string): void => redirectTo(`${process.env.REACT_APP_AUTH_APP_BASE_URL}/logout?${createAuthCallback(callback)}`);

export const reloadLocation = (query?: string): void => {
  if (query) {
    window.location.search = query;
  } else window.location.reload();
};

export const getLocationPath = () => window.location.pathname;
